import { useEffect, useId, useRef, type ReactNode } from 'react'
import { X } from 'lucide-react'
import ModalPortal from './ModalPortal'
import './SelfHealingDialog.css'

export default function SelfHealingDialog({ title, children, onClose }: { title: string; children: ReactNode; onClose: () => void }) {
  const titleId = useId()
  const dialogRef = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    const dialog = dialogRef.current!
    dialog.showModal()
    return () => dialog.close()
  }, [])
  return <ModalPortal>
    <dialog ref={dialogRef} className="self-healing-settings-dialog" aria-labelledby={titleId}
      onCancel={event => { event.preventDefault(); onClose() }}
      onClick={event => { if (event.target === event.currentTarget) onClose() }}>
      <div className="self-healing-settings-dialog__content">
        <header>
          <h2 id={titleId}>{title}</h2>
          <button type="button" aria-label={`Close ${title}`} onClick={onClose}><X size={20} aria-hidden /></button>
        </header>
        {children}
      </div>
    </dialog>
  </ModalPortal>
}
